;"use strict";

!(function ($){

    function autoHeightMainResize(body_class, header){
        if(body_class.length){
            body_class.find(".main-content").removeAttr("style");
            body_class.find(".main-content").css({
                "padding-top": header.height() + 'px',
                "margin-top": 0
            });
        }
    }
    //autoHeightMainResize($("body.loyalty"), $("[data-section-id=\"header\"]"));
    //autoHeightMainResize($("body.contact-us"), $("[data-section-id=\"header\"]"));


    function setCenterPositionContactCampaign(block){
        if (block.length){
            block.removeAttr("style");
            block.css({
                "transform": "translate(0, "+ (-$(".custom-contact-us .campaign_data .inner").outerHeight() / 2)+"px)"
            })
        }
    }setCenterPositionContactCampaign($(".custom-contact-us .campaign_data .inner"));


    function contactPageSetPadding(block){
        if($(window).width() <= 767){
            block.removeAttr("style");
            block.css({
                "padding-top": ( $(".custom-contact-us .campaign_data .inner").outerHeight() / 2 ) + 30 + 'px'
            });
        }else{
            block.removeAttr("style");
        }
    }contactPageSetPadding($(".campaign_map"));

    $(window).on("resize", function (){
        //autoHeightMainResize($("body.loyalty"), $("[data-section-id=\"header\"]"));
        //autoHeightMainResize($("body.contact-us"), $("[data-section-id=\"header\"]"));
        setCenterPositionContactCampaign($(".custom-contact-us .campaign_data .inner"));
        contactPageSetPadding($(".campaign_map"));
    });


    /*$('.affirm-as-low-as').one('DOMSubtreeModified', function(){
        console.log("AFFIRM WIDGET ADDED");
        setTimeout(function (){
            /!*$(".affirm-as-low-as:contains('Starting at')").html(function(_, html) {
                return html.split('Starting at').join("<span class='affirm-as-low-as--top'>Starting at</span>");
            });*!/
            $(".affirm-as-low-as").addClass("ggggggggggg");
            let fff =
            $(".ggggggggggg:contains('Starting at')").html(function(_, html) {
                return html.replace(/(Starting at)/g, '<span class="smallcaps">$1</span>');
            });
            let _clone = $(".ggggggggggg").clone(true);
            $("#affirm-as-low-as_clone").append(fff);

        }, 1000);
    });*/
    /*$("#affirm-as-low-as_clone").one('DOMSubtreeModified', function(){
        console.log("affirm-as-low-as_clone CLONE ADDED");
        $("#affirm-as-low-as_clone:contains('Starting at')").html(function(_, html) {
            return html.split('Starting at').join("<span class='affirm-as-low-as--top'>Starting at</span>");
        });
    });*/

    /*if($(".js_back_to_top").length > 0){

    }*/

    // all anchors

    $(document).on('click', 'a[href^="#"]', function(event) {

        var id = $(this).attr("href");

        var target = $(id).offset().top;
        //console.log(target);

        $('html, body').animate({scrollTop:target}, 250);

        event.preventDefault();
    });

})(jQuery);

jQuery(window).on("load", function (){
    jQuery("div.rebuy-widget:empty").css({
        "display": "none"
    });
    $(".template-page.reviews .stamped-summary-caption.stamped-summary-caption-1 .stamped-summary-text-1").append("<strong> out of 5.0 stars</strong>");
    /*setTimeout(function (){
        jQuery("#affirm-as-low-as_clone>p:contains('Starting at')").html(function(_, html) {
            return html.split('Starting at').join("<span class='affirm-as-low-as--top'>Starting at</span>");
        });
        //jQuery("#affirm-as-low-as_clone").html(jQuery("#affirm-as-low-as_clone").html());
        //console.log(jQuery("#affirm-as-low-as_clone").html());
    }, 1000);*/

  let _fl = true;
     setTimeout(function(){
      $("#launcher").parent('div').addClass("parent_launcher");
    }, 1000);
  
  jQuery(window).on("scroll", function (){
    if(_fl){
      setTimeout(function(){
        $("#launcher").parent('div').addClass("parent_launcher");
        _fl = false;
      }, 1000);
    }
  });
  
});